import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-admin-navbar',
    templateUrl: './admin-navbar.component.html',
    styleUrls: ['./admin-navbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminNavbarComponent implements OnInit {

    constructor(
        public router: Router
    ) { }

    ngOnInit() { }

    logoutAdmin() {
        localStorage.clear();
        this.router.navigateByUrl('/admin-login');
    }

}